import { render, staticRenderFns } from "./UserEditAction.vue?vue&type=template&id=4288cf66"
import script from "./UserEditAction.vue?vue&type=script&lang=js"
export * from "./UserEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports